export default function () {
  const dom = useDom();
  const queryParams = ref(new URLSearchParams(dom?.window.location.search));

  function addOrUpdateQueryParam(key: string, value: string) {
    if (!import.meta.client) {
      return;
    }
    queryParams.value.set(key, value);

    const newUrl = `${dom?.window.location.pathname}?${queryParams.value.toString()}`;
    dom?.window.history.replaceState({}, '', newUrl);
  }

  function clearQueryParams() {
    if (!import.meta.client) {
      return;
    }
    queryParams.value = new URLSearchParams();

    const newUrl = `${dom?.window.location.pathname}`;
    dom?.window.history.replaceState({}, '', newUrl);
  }

  return {
    addOrUpdateQueryParam,
    clearQueryParams,
  };
}
